import React from "react";
import "../App.css";

const AboutUs = () => (
  <>
    <section className="page-header">
      <h1>Über uns</h1>
      <p>Tradition, Innovation und Leidenschaft</p>
    </section>
    <section className="aboutus-section" id="ueber-uns">
    <div className="aboutus-header">
      {/* H2 Removed from here */}
      <div className="aboutus-divider"></div>
    </div>
    <div className="aboutus-content">
      <div className="aboutus-founder">
        <img
          src="/CG.png"
          alt="Christopher Grabner"
          className="aboutus-logo"
        />
        <div>
          <h3>Christopher Grabner</h3>
          <p>Gründer & Inhaber</p>
          <p className="aboutus-year">Gegründet 2024</p>
        </div>
      </div>
      <div className="aboutus-text">
        <p>
          <strong>CG Fliesen</strong> steht für Qualität, Präzision und Leidenschaft im Fliesenleger-Handwerk. Als regionaler Fachbetrieb bringt Christopher Grabner und sein Team jahrelange Erfahrung und höchste Sorgfalt in jedes Projekt ein.
        </p>
        <p>
          Ob Bad, Küche, Wohnraum oder Außenbereich – wir bieten maßgeschneiderte Lösungen für private und gewerbliche Kunden. Unser Anspruch ist es, Ihre Wünsche mit handwerklichem Können und modernen Designs umzusetzen.
        </p>
        <p>
          Vertrauen Sie auf einen regionalen Fachbetrieb, der mit Herz und Verstand arbeitet – für langlebige und ästhetische Ergebnisse.
        </p>
      </div>
    </div>
    <section className="google-reviews">
  <h3>Das sagen unsere Kunden</h3>
  <div className="review-list">
    <div className="review">
      <span className="stars">★★★★★</span>
      <p>Vielen Dank für unser traumhaftes Bad! Christopher hat perfekt und sehr sauber gearbeitet. Wir sind super zufrieden und würden ihn sofort wieder anfragen, wenn es wieder etwas zu tun gibt. Danke!</p>
      <span className="review-author">– Sarah Freudenthaler, Google Bewertung</span>
    </div>
    <div className="review">
      <span className="stars">★★★★★</span>
      <p>Jung, dynamisch und kompetent.
Perfekte Arbeit! Handwerkskunst vom Feinsten!
Sehr empfehlenswert.</p>
      <span className="review-author">– Stephan Graf , Google Bewertung</span>
    </div>
    <div className="review">
      <span className="stars">★★★★★</span>
      <p>Wir haben mit der Firma CG Fliesen den allerbesten Fliesenleger gefunden. Beratung und Ausführung der Arbeiten übertrafen  unseren Erwartungen. Wer Fliesenarbeiten zu vergeben hat, wird mit dem Christopher und seinem Team nur die besten Erfahrungen machen.
Fairer Preis, perfekte Arbeit und die Baustelle war immer sauber.<br/>
Fa. SKIPPEX GmbH, Oskar Haid, GF</p>
      <span className="review-author">– Oskar Haid , Google Bewertung</span>
    </div>
    {/* Weitere Bewertungen */}
  </div>
  <a
    href="https://www.google.com/maps/place/CG+Fliesen+Christopher+Grabner/@47.1691432,15.6180089,17z/data=!4m8!3m7!1s0x476e455da32816e9:0x657943c91dc1b909!8m2!3d47.1691432!4d15.6180089!9m1!1b1!16s%2Fg%2F11vy5ttyvw?entry=ttu"
    target="_blank"
    rel="noopener noreferrer"
    className="google-review-link"
  >
    Alle Google Bewertungen ansehen
  </a>
</section>
  </section>
  </>
);

export default AboutUs;
